<sh-card *ngIf="!landingPageMode" label="Applications for {{ title$ | async }}">
  <api-call-gate class="apps" [apiCall]="usedAPICall">
    <ng-template #lastSuccessfulData *ngIf="apps$ | async as apps">
      <sh-empty-state
        *ngIf="apps.length === 0"
        icon="list-viewmode"
        label="No applications available"
      >
      </sh-empty-state>
      <div class="app" *ngFor="let app of apps">
        <div class="link-title">{{ app.displayName }}</div>
        <img [src]="app.image" alt="app display name" />
        <ul>
          <li *ngFor="let link of app.links">
            <a [href]="link.url" target="_blank"
              ><sh-icon
                icon="open-link"
                size="xs"
                style="display: inline-block"
              ></sh-icon
              >{{ link.text }}</a
            >
          </li>
        </ul>
      </div>
    </ng-template>
  </api-call-gate>
</sh-card>

<!-- flavor for landing page -->
<ng-container *ngIf="landingPageMode">
  <api-call-gate class="apps" [apiCall]="usedAPICall">
    <ng-template #lastSuccessfulData *ngIf="apps$ | async as apps">
      <ng-container *ngFor="let app of apps">
        <a
          class="landing-page"
          *ngFor="let link of app.links"
          [href]="link.url"
          target="_blank"
          ><sh-text size="body-1" class="custom-tool">
            {{ app.displayName + ': ' + link.text }}</sh-text
          ></a
        >
      </ng-container>
    </ng-template>
  </api-call-gate>
</ng-container>
